































































import Vue from "vue";
import TemplateSelection from "../../components/PivotTemplateSelection.vue";
import TransitionExpand from "../../components/TransitionExpand.vue";
import LeadsPivotFilters from "./LeadsPivotFilters.vue";
import PivotGrid from "../../components/PivotGrid.vue";
import PivotChart from "../../components/PivotChart.vue";
import { PivotDefinitieType } from "../../PublicEnums";
import { FilterPivotLeadValues } from "./LeadsPivotFilters.vue";
import axios, { AxiosPromise } from "axios";
import get from "lodash-es/get";
import { EventBus } from "../../lib/EventBus";
import debounce from "lodash-es/debounce";
import isEmpty from "lodash-es/isEmpty";
import find from "lodash-es/find";
import moment from "moment";
import { FixedPeriodType, LookupItemViewModel } from "../../TypeScriptModels";

interface PivotLeadQueryViewModel {
  FromDate: string;
  ToDate: string;
  ComparePeriodData: boolean;
  FromDateCompare: string;
  ToDateCompare: string;
  Zones: any[];
  Autobedrijven: any[];
  Vestigingen: any[];
  Modellen: any[];
  AutoSoorten: any[];
  LeadTypen: any[];
  LeadSoorten: any[];
  LeadResultaten: any[];
}

interface PivotLeadViewModel {
  Aangemaakt: string;
  AaWk: number;
  ZoneID: number;
  Zone: string;
  Contact: string;
  Afgerond: string;
  AfWk: number;
  Bron: string;
  Open: number;
  AutobedrijfID: number;
  Autobedrijf: string;
  VestigingID: number;
  Vestiging: string;
  LeadTypeID: number;
  LeadType: string;
  AutoSoortID: number;
  AutoSoort: string;
  SoortLeadID: number;
  SoortLead: string;
  DTCT: number;
  Deadline: string;
  DeadlineG: number;
  DeadlineGehaald: string;
  LeadResultaatID: number;
  LeadResultaat: string;
  HasOfferteID: number;
  HasOfferte: string;
  HasOrderID: number;
  HasOrder: string;
  GewenstModel: string;
  //importeurspecifieke velden:
  Merk?: string;
  Leverancier?: string;
}

interface PivotLeadsViewModel {
  Leads: PivotLeadViewModel[];
}

interface PivotGridFieldsViewModel {
  Fields: string;
}

interface LookupLeadsViewModel {
  Autobedrijven: LookupItemViewModel[];
  Zones: LookupItemViewModel[];
  Vestigingen: LookupItemViewModel[];
  LeadTypes: LookupItemViewModel[];
  AutoSoorten: LookupItemViewModel[];
  LeadSoorten: LookupItemViewModel[];
  LeadResultaten: LookupItemViewModel[];
}

export default Vue.extend({
  components: {
    TemplateSelection,
    TransitionExpand,
    LeadsPivotFilters,
    PivotGrid,
    PivotChart,
  },

  created() {
    this.getSavedGridPreferences();
    this.getDataDebounced = debounce(() => {
      this.loadLeads();
    }, 500);
  },

  mounted() {
    this.getLookupData();
  },

  computed: {
    templateSelection(): any {
      return this.$refs["templateSelection"];
    },

    filters(): any {
      return this.$refs["filters"];
    },

    pivotgrid(): any {
      return this.$refs["pivotgrid"];
    },

    pivotchart(): any {
      return this.$refs["pivotchart"];
    },

    triangle(): string {
      return this.showFilterFields ? "fas fa-caret-up" : "fas fa-caret-down";
    },

    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },

    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    zoneFields(): string[] {
      return this.$store.getters.zoneFields;
    },

    defaultgridFields(): any[] {
      return [
        {
          caption: this.$i18n.t("gridcreationdate"),
          dataField: "Aangemaakt",
        },
        {
          caption: this.$i18n.t("gridcreationweeknumber"),
          dataField: "AaWk",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridcreationyearweek"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridcreationyearmonth"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridcreationyear"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridcreationmonth"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridcreationday"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridregionid"),
          dataField: "ZoneID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridregion"),
          dataField: "Zone",
          visible: this.zoneGebruiker,
        },
        {
          caption: this.$i18n.t("gridfirstcontact"),
          dataField: "Contact",
          area: "filter",
        },
        {
          caption: this.$i18n.t("gridfinisheddate"),
          dataField: "Afgerond",
          area: "filter",
        },
        {
          caption: this.$i18n.t("gridfinishedweeknumber"),
          dataField: "AfWk",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridfinishedyearweek"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridfinishedyearmonth"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridfinishedyear"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridfinishedmonth"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridfinishedday"), // Veld wordt gevuld middels de selector property
        },
        {
          caption: this.$i18n.t("gridleadbron"),
          dataField: "Bron",
        },
        {
          caption: this.$i18n.t("gridopenfinished"),
          summaryType: "sum",
          dataType: "number",
        },
        {
          caption: this.$i18n.t("griddealer"),
          dataField: "Autobedrijf",
          area: "row",
          visible: this.zoneGebruiker,
        },
        {
          caption: this.$i18n.t("griddealerid"),
          dataField: "AutobedrijfID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridlocation"),
          dataField: "Vestiging",
          area: "row",
        },
        {
          caption: this.$i18n.t("gridlocationid"),
          dataField: "VestigingID",
          visible: false,
        },
        {
          caption: this.$i18n.t("open"),
          dataField: "Open",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridleadtype"),
          dataField: "LeadType",
          area: "column",
        },
        {
          caption: this.$i18n.t("gridleadtypeid"),
          dataField: "LeadTypeID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridcarkind"),
          dataField: "AutoSoort",
          area: "row",
        },
        {
          caption: this.$i18n.t("gridcarkindid"),
          dataField: "AutoSoortID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridleadkind"),
          dataField: "SoortLead",
          area: "row",
        },
        {
          caption: this.$i18n.t("gridleadkindid"),
          dataField: "SoortLeadID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridthroughtimefirstcontact"),
          dataField: "DTCT",
          dataType: "number",
          summaryType: "avg",
        },
        {
          caption: this.$i18n.t("griddeadlineimporter"),
          dataField: "Deadline",
        },
        {
          caption: this.$i18n.t("griddeadlinemade"),          
          dataField: "DeadlineGehaald",
        },
        {
          caption: this.$i18n.t("griddeadlinemade1"),          
          dataField: "DeadlineG",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridcount"),
          summaryType: "count",
          area: "data",
        },
        {
          caption: this.$i18n.t("leadresultaatid"),
          dataField: "LeadResultaatID",
          visible: false,
        },
        {
          caption: this.$i18n.t("leadresultaat"),
          dataField: "LeadResultaat",
        },
        {
          caption: this.$i18n.t("hasofferteid"),
          dataField: "HasOfferteID",
          visible: false,
        },
        {
          caption: this.$i18n.t("hasofferte"),
          dataField: "HasOfferte",
        },
        {
          caption: this.$i18n.t("hasorderid"),
          dataField: "HasOrderID",
          visible: false,
        },
        {
          caption: this.$i18n.t("hasorder"),
          dataField: "HasOrder",
        },
        {
          caption: this.$i18n.t("gewenstmodel"),
          dataField: "GewenstModel",
        },
      ] as any[];
      }
  },

  data() {
    return {
      showFilterFields: true,
      oldGridFields: null as
        | null
        | {
            dataField: string;
            caption: string;
            visible?: boolean;
            selector?: any;
          }[],
      pivotgridData: [] as PivotLeadViewModel[],
      getDataDebounced: null as null | Function,
      selectedOptions: {
        period: null as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        leadTypesValue: [] as any[],
        soortenLeadValue: [] as any[],
        autosoortenValue: [] as any[],
        leadResultatenValue: [] as any[],
        merkenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
        comparePeriodData: false as boolean,
        customFromDateCompare: new Date(),
        customToDateCompare: new Date(),
      } as FilterPivotLeadValues,
      lookups: {} as LookupLeadsViewModel,
      extragridFields: [] as string[],
      pivotDefinitieType: PivotDefinitieType.Leads as Number,
    };
  },

  methods: {
    // TemplateSelection functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    loadTemplateSettings(filterSettings: string, pivotSettings: string): void {
      this.setGridFields(pivotSettings);
      this.filters.setPreferences(filterSettings);
    },

    onTemplateSaveClick(): void {
      this.templateSelection.processSave(
        this.getFilterFields(),
        this.getGridFields()
      );
    },

    // Filter functions  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    onFiltersInitialised() {
      this.onFilterPreferencesChanged();
    },

    onFilterPreferencesChanged() {
      this.handleDataChanged();
    },

    handleDataChanged(): void {
      if (!!this.getDataDebounced) this.getDataDebounced();
    },

    toggleShowHideFilterFields(): void {
      this.showFilterFields = !this.showFilterFields;
    },

    getFilterFields(): string {
      let filters = this.filters.getPreferences();
      return JSON.stringify(filters);
    },

    // Grid functions  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    loadLeads(): void {
      const queryData = this.getQueryData() as PivotLeadQueryViewModel;
      axios
        .post("/api/backend/v1/dashboard/leads/grid/query", queryData)
        .then((response) => {
          if (!!response && !!response.data) {
            this.setGridData(response.data.Leads);
            this.fillGrid(this.oldGridFields, this.pivotgridData);
          }
        })
        .catch((error) => {});
    },

    filterForPermissions(fields: {dataField: string; caption: string; visible?: boolean; selector?: any;}[]): {dataField: string; caption: string; visible?: boolean; selector?: any;}[]{
      fields.forEach(f => {
        if(this.zoneFields.includes(f.dataField))
          f.visible = this.zoneGebruiker
      }, this)
      return fields
    },

    getLookupData(): void {
      axios
        .get("/api/backend/v1/dashboard/leads/grid/lookups")
        .then((response) => {
          if (!!response && !!response.data) {
            this.lookups = response.data;
          }
        })
        .catch((error) => {});
    },

    //vult autobedrijvennaam, zones en vestigingennamen obv id aan etc...
    setGridData(leads: PivotLeadViewModel[]): void {
      leads = leads || [];
      if (this.multipleMakes && !isEmpty(this.selectedOptions.merkenValue)) {
        this.pivotgridData = leads.filter(
          (lead) =>
            !!lead.Merk &&
            !!this.selectedOptions.merkenValue.find((m) => m.Id === lead.Merk)
        );
      } else {
        this.pivotgridData = leads;
      }

      if (isEmpty(this.pivotgridData)) return;

      this.pivotgridData.forEach((record) => {
        let autobedrijfRecord = find(
          this.lookups.Autobedrijven,
          (row) => row.LookupID === record.AutobedrijfID.toString()
        );
        let zoneRecord = find(
          this.lookups.Zones,
          (row) => row.LookupID === record.ZoneID.toString()
        );
        let vestigingRecord = !!record.VestigingID
          ? find(
              this.lookups.Vestigingen,
              (row) => row.LookupID === record.VestigingID.toString()
            )
          : null;
        let leadTypeRecord = find(
          this.lookups.LeadTypes,
          (row) => row.LookupID === record.LeadTypeID.toString()
        );
        let autoSoortRecord = find(
          this.lookups.AutoSoorten,
          (row) => row.LookupID === record.AutoSoortID.toString()
        );
        //hack om onbekend in pivot grid ook te vertalen, beter zou zijn onbekend niet (in de enum in de backend) op te nemen
        if (!!autoSoortRecord && autoSoortRecord.LookupID === "0")
          autoSoortRecord.LookupValue = `${this.$i18n.t("unknown")}`;

        let soortLeadRecord = find(
          this.lookups.LeadSoorten,
          (row) => row.LookupID === record.SoortLeadID.toString()
        );
        let leadResultaatRecord = find(
          this.lookups.LeadResultaten,
          (row) => row.LookupID === record.LeadResultaatID.toString()
        );

        record.Zone = !!zoneRecord
          ? zoneRecord.LookupValue
          : `${this.$i18n.t("unknown")}`;
        record.Autobedrijf = !!autobedrijfRecord
          ? autobedrijfRecord.LookupValue
          : `${this.$i18n.t("unknown")}`;
        record.Vestiging = !!vestigingRecord
          ? vestigingRecord.LookupValue
          : `${this.$i18n.t("nobranch")}`;
        record.AutoSoort = !!autoSoortRecord
          ? autoSoortRecord.LookupValue
          : `${this.$i18n.t("unknown")}`;
        record.LeadType = !!leadTypeRecord
          ? leadTypeRecord.LookupValue
          : `${this.$i18n.t("unknown")}`;
        record.SoortLead = !!soortLeadRecord
          ? soortLeadRecord.LookupValue
          : `${this.$i18n.t("unknown")}`;
        record.LeadResultaat = !!leadResultaatRecord
          ? leadResultaatRecord.LookupValue
          : `${this.$i18n.t("unknown")}`;
        record.HasOfferte =
          record.HasOfferteID === 1
            ? `${this.$i18n.t("hasoffertetrue")}`
            : `${this.$i18n.t("hasoffertefalse")}`;
        record.DeadlineGehaald =
          record.DeadlineG === 1
            ? `${this.$i18n.t("yes")}`
            : record.DeadlineG === 0 
              ? `${this.$i18n.t("no")}` 
              : `${this.$i18n.t("unknown")}`;
        record.HasOrder =
          record.HasOrderID === 1
            ? `${this.$i18n.t("hasordertrue")}`
            : `${this.$i18n.t("hasorderfalse")}`;
        record.GewenstModel = record.GewenstModel
          ? record.GewenstModel
          : `${this.$i18n.t("unknown")}`;
      });
    },

    getSavedGridPreferences(): void {
      axios
        .get("/api/backend/v1/identity/preferences/dashboard/pivot/grid")
        .then((response) => {
          if (!!response && !!response.data) {
            if (
              !isEmpty(response.data.ExtraVelden) &&
              Array.isArray(response.data.ExtraVelden)
            ) {
              this.extragridFields = response.data.ExtraVelden;
            }

            if (!!response.data.FilterSettings) {
              this.oldGridFields = this.filterForPermissions(JSON.parse(
                response.data.FilterSettings.Fields
              ));
              
            } else {
              this.oldGridFields = this.defaultgridFields;
            }

            if (!isEmpty(this.extragridFields)) {
              this.extragridFields.forEach((extraveld) => {
                if (
                  !!this.oldGridFields &&
                  !this.oldGridFields.find((a) => a.dataField === extraveld)
                ) {
                  this.oldGridFields.push({
                    dataField: extraveld,
                    caption: this.$t("grid" + extraveld).toString(),
                  });
                }
              });
            }

            this.setGridSelectorsAndHeaders(this.oldGridFields);
          }
        })
        .catch((error) => {
          EventBus.$emit("add-toastr", {
            text: this.$t("pivotgridfieldserror").toString(),
            type: "error",
          });
        });
    },

    saveGridPreferences(newGridFields: string): void {
      let model = { Fields: newGridFields } as PivotGridFieldsViewModel;
      axios
        .post(
          "/api/backend/v1/identity/preferences/dashboard/pivot/grid",
          model,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .catch((error) => {
          EventBus.$emit("add-toastr", {
            text: this.$t("gridsaveerror").toString(),
            type: "error",
          });
        });
    },

    fillGrid(
      fields:
        | null
        | {
            caption: string;
            dataField: string;
            visibility?: boolean;
            selector?: any;
          }[],
      store: PivotLeadViewModel[]
    ): void {
      if (fields === null) return;
      this.pivotgrid.fillGrid(this.filterForPermissions(fields), store);
      this.bindChart();
    },

    getQueryData(): PivotLeadQueryViewModel {
      const isCustomInput =
        get(this.selectedOptions, "period.Id", FixedPeriodType.ThisYear) ===
        FixedPeriodType.FreePeriod;

      const isComparePeriodData = this.selectedOptions.comparePeriodData;

      const fromDate = isCustomInput
        ? (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString()
        : this.selectedOptions.periodFromDate.toISOString();
      const toDate = isCustomInput
        ? (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString()
        : this.selectedOptions.periodToDate.toISOString();

      const fromDateCompare = isComparePeriodData
        ? (moment(this.selectedOptions.customFromDateCompare)).local().startOf("day").toDate().toISOString()
        : null;
      const toDateCompare = isComparePeriodData
        ? (moment(this.selectedOptions.customToDateCompare)).local().endOf("day").toDate().toISOString()
        : null;		

      const model = {
        FromDate: fromDate,
        ToDate: toDate,

        FromDateCompare: fromDateCompare,
        ToDateCompare: toDateCompare,

        Zones: get(this.selectedOptions as Object, "zonesValue", []).map(
          (elem: any) => Number(elem["Id"])
        ),
        Autobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        Vestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        Modellen: get(this.selectedOptions as Object, "modellenValue", []).map(
          (elem: any) => String(elem["Id"])
        ),
        AutoSoorten: get(
          this.selectedOptions as Object,
          "autosoortenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        LeadSoorten: get(
          this.selectedOptions as Object,
          "soortenLeadValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        LeadTypen: get(
          this.selectedOptions as Object,
          "leadTypesValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        LeadResultaten: get(
          this.selectedOptions as Object,
          "leadResultatenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
      } as PivotLeadQueryViewModel;

      return model;
    },

    //corrigeert doet de vertalingen en set selectors indien nodig
    setGridSelectorsAndHeaders(
      dataList: null | { dataField: string; caption: string; selector?: any}[]
    ) {
      if (dataList === null || isEmpty(dataList)) return;
      dataList.forEach((field) => {
        switch (field.caption) {
          case this.$i18n.t("gridcreationyearweek", "nl"):
          case this.$i18n.t("gridcreationyearweek", "en"):
            field.caption = this.$i18n.t("gridcreationyearweek").toString();
            field.selector = function(data: any) {
              let year = data.Aangemaakt.substring(0, 4);
              return `${year}-${data.AaWk}`;
            };
            break;
          case this.$i18n.t("gridcreationyearmonth", "nl"):
          case this.$i18n.t("gridcreationyearmonth", "en"):
            field.caption = this.$i18n.t("gridcreationyearmonth").toString();
            field.selector = function(data: any) {
              let yearmnd = data.Aangemaakt.substring(0, 7);
              return `${yearmnd}`;
            };
            break;
          case this.$i18n.t("gridcreationyear", "nl"):
          case this.$i18n.t("gridcreationyear", "en"):
            field.caption = this.$i18n.t("gridcreationyear").toString();
            field.selector = function(data: any) {
              let year = data.Aangemaakt.substring(0, 4);
              return `${year}`;
            };
            break;
          case this.$i18n.t("gridcreationmonth", "nl"):
          case this.$i18n.t("gridcreationmonth", "en"):
            field.caption = this.$i18n.t("gridcreationmonth").toString();
            field.selector = function(data: any) {
              let mnd = data.Aangemaakt.substring(5, 7);
              return `${mnd}`;
            };
            break;
          // TODO: Indien er ook vergelijking op week als optie wordt toegevoegd, dan zal er extra data opgehaald moeten gaan
          // TODO: worden betreffende de dag van de week. Deze week met vorige week vergelijken op dag nummer zorgt er voor dat
          // TODO: de data naast elkaar komt te staan. Met dag van de week kan de data wel "over" elkaar geplaatst worden.
          // case this.$i18n.t("gridcreationweek", "nl"):
          // case this.$i18n.t("gridcreationweek", "en"):
          //   field.caption = this.$i18n.t("gridcreationweek");
          //   field.selector = function(data: any) {
          //     return `${data.AaWk}`;
          //   };
          //   break;
          case this.$i18n.t("gridcreationday", "nl"):
          case this.$i18n.t("gridcreationday", "en"):
            field.caption = this.$i18n.t("gridcreationday").toString();
            field.selector = function(data: any) {
              let day = data.Aangemaakt.substring(8, 10);
              return `${day}`;
            };
            break;
          case this.$i18n.t("gridopenfinished", "nl"):
          case this.$i18n.t("gridopenfinished", "en"):
            field.caption = this.$i18n.t("gridopenfinished").toString();
            field.selector = function(data: any) {
              return "" + data.Open !== "0" ? "Open" : "Afgesloten";
            };
            break;
          case this.$i18n.t("gridfinishedyearweek", "nl"):
          case this.$i18n.t("gridfinishedyearweek", "en"):
            field.caption = this.$i18n.t("gridfinishedyearweek").toString();
            field.selector = function(data: any) {
              if (!!data.Afgerond) {
                let year = data.Afgerond.substring(0, 4);
                return `${year}-${data.AfWk}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridfinishedyearmonth", "nl"):
          case this.$i18n.t("gridfinishedyearmonth", "en"):
            field.caption = this.$i18n.t("gridfinishedyearmonth").toString();
            field.selector = function(data: any) {
              if (!!data.Afgerond) {
                let yearmnd = data.Afgerond.substring(0, 7);
                return `${yearmnd}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridfinishedyear", "nl"):
          case this.$i18n.t("gridfinishedyear", "en"):
            field.caption = this.$i18n.t("gridfinishedyear").toString();
            field.selector = function(data: any) {
              if (!!data.Afgerond) {
                let year = data.Afgerond.substring(0, 4);
                return `${year}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridfinishedmonth", "nl"):
          case this.$i18n.t("gridfinishedmonth", "en"):
            field.caption = this.$i18n.t("gridfinishedmonth").toString();
            field.selector = function(data: any) {
              if (!!data.Afgerond) {
                let month = data.Afgerond.substring(5, 7);
                return `${month}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridfinishedday", "nl"):
          case this.$i18n.t("gridfinishedday", "en"):
            field.caption = this.$i18n.t("gridfinishedday").toString();
            field.selector = function(data: any) {
              if (!!data.Afgerond) {
                let day = data.Afgerond.substring(8, 10);
                return `${day}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridcreationdate", "nl"):
          case this.$i18n.t("gridcreationdate", "en"):
            field.caption = this.$i18n.t("gridcreationdate").toString();
            break;
          case this.$i18n.t("gridcreationweeknumber", "nl"):
          case this.$i18n.t("gridcreationweeknumber", "en"):
            field.caption = this.$i18n.t("gridcreationweeknumber").toString();
            break;
          case this.$i18n.t("gridregionid", "nl"):
          case this.$i18n.t("gridregionid", "en"):
            field.caption = this.$i18n.t("gridregionid").toString();
            break;
          case this.$i18n.t("gridregion", "nl"):
          case this.$i18n.t("gridregion", "en"):
            field.caption = this.$i18n.t("gridregion").toString();
            break;
          case this.$i18n.t("gridfirstcontact", "nl"):
          case this.$i18n.t("gridfirstcontact", "en"):
            field.caption = this.$i18n.t("gridfirstcontact").toString();
            break;
          case this.$i18n.t("gridfinisheddate", "nl"):
          case this.$i18n.t("gridfinisheddate", "en"):
            field.caption = this.$i18n.t("gridfinisheddate").toString();
            break;
          case this.$i18n.t("gridfinishedweeknumber", "nl"):
          case this.$i18n.t("gridfinishedweeknumber", "en"):
            field.caption = this.$i18n.t("gridfinishedweeknumber").toString();
            break;
          case this.$i18n.t("gridleadbron", "nl"):
          case this.$i18n.t("gridleadbron", "en"):
            field.caption = this.$i18n.t("gridleadbron").toString();
            break;
          case this.$i18n.t("griddealer", "nl"):
          case this.$i18n.t("griddealer", "en"):
            field.caption = this.$i18n.t("griddealer").toString();
            break;
          case this.$i18n.t("griddealerid", "nl"):
          case this.$i18n.t("griddealerid", "en"):
            field.caption = this.$i18n.t("griddealerid").toString();
            break;
          case this.$i18n.t("gridlocation", "nl"):
          case this.$i18n.t("gridlocation", "en"):
            field.caption = this.$i18n.t("gridlocation").toString();
            break;
          case this.$i18n.t("gridlocationid", "nl"):
          case this.$i18n.t("gridlocationid", "en"):
            field.caption = this.$i18n.t("gridlocationid").toString();
            break;
          case this.$i18n.t("gridleadtype", "nl"):
          case this.$i18n.t("gridleadtype", "en"):
            field.caption = this.$i18n.t("gridleadtype").toString();
            break;
          case this.$i18n.t("gridleadtypeid", "nl"):
          case this.$i18n.t("gridleadtypeid", "en"):
            field.caption = this.$i18n.t("gridleadtypeid").toString();
            break;
          case this.$i18n.t("gridcarkind", "nl"):
          case this.$i18n.t("gridcarkind", "en"):
            field.caption = this.$i18n.t("gridcarkind").toString();
            break;
          case this.$i18n.t("gridcarkindid", "nl"):
          case this.$i18n.t("gridcarkindid", "en"):
            field.caption = this.$i18n.t("gridcarkindid").toString();
            break;
          case this.$i18n.t("gridleadkind", "nl"):
          case this.$i18n.t("gridleadkind", "en"):
            field.caption = this.$i18n.t("gridleadkind").toString();
            break;
          case this.$i18n.t("gridleadkindid", "nl"):
          case this.$i18n.t("gridleadkindid", "en"):
            field.caption = this.$i18n.t("gridleadkindid").toString();
            break;
          case this.$i18n.t("gridthroughtimefirstcontact", "nl"):
          case this.$i18n.t("gridthroughtimefirstcontact", "en"):
            field.caption = this.$i18n
              .t("gridthroughtimefirstcontact")
              .toString();
            break;
          case this.$i18n.t("griddeadlineimporter", "nl"):
          case this.$i18n.t("griddeadlineimporter", "en"):
            field.caption = this.$i18n.t("griddeadlineimporter").toString();
            break;
          case this.$i18n.t("griddeadlinemade", "nl"):
          case this.$i18n.t("griddeadlinemade", "en"):
            field.caption = this.$i18n.t("griddeadlinemade").toString();
            break;
          case this.$i18n.t("gridcount", "nl"):
          case this.$i18n.t("gridcount", "en"):
            field.caption = this.$i18n.t("gridcount").toString();
            break;
          case this.$i18n.t("leadresultaat", "nl"):
          case this.$i18n.t("leadresultaat", "en"):
            field.caption = this.$i18n.t("leadresultaat").toString();
            break;
          case this.$i18n.t("hasofferte", "nl"):
          case this.$i18n.t("hasofferte", "en"):
            field.caption = this.$i18n.t("hasofferte").toString();
            break;
          case this.$i18n.t("hasorder", "nl"):
          case this.$i18n.t("hasorder", "en"):
            field.caption = this.$i18n.t("hasorder").toString();
            break;
          case this.$i18n.t("gewenstmodel", "nl"):
          case this.$i18n.t("gewenstmodel", "en"):
            field.caption = this.$i18n.t("gewenstmodel").toString();
            break;
        }
        // vertaal extra velden
        if (!isEmpty(this.extragridFields)) {
          this.extragridFields.forEach((extraVeld) => {
            if (field.dataField === extraVeld) {
              field.caption = this.$i18n.t("grid" + extraVeld).toString();
            }
          });
        }
      });
    },

    onGridFieldsChanged(): void {
      if (this.pivotgrid.fieldsLoaded()) {
        let currentGridFields = this.getGridFields();
        if (currentGridFields !== JSON.stringify(this.oldGridFields)) {
          this.saveGridPreferences(currentGridFields);
        }
        this.oldGridFields = JSON.parse(currentGridFields);
        this.setGridSelectorsAndHeaders(this.oldGridFields);
      }
    },

    getGridFields(): string {
      let currentFields = this.pivotgrid.getFields();
      return JSON.stringify(currentFields);
    },

    setGridFields(jsonstring: string): void {
      if (jsonstring === "{}") return;

      let newFields = this.filterForPermissions(JSON.parse(jsonstring));
      if (isEmpty(newFields)) return;
      this.pivotgrid.setFields(newFields);
      this.bindChart();
    },

    bindChart(): void {
      const chart = this.pivotchart.getInstance();
      this.pivotgrid.bindChart(chart, false);
    },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  },
});
